import { Component, ElementRef, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ModalService } from './modal.service';

@Component({
    selector: 'blog-modal',
    templateUrl: 'modal.component.html',
    styleUrls: ['modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [CommonModule],
})
export class ModalComponent implements OnInit, OnDestroy {
    @Input() public id?: string;
    private element: any;

    public constructor(
        private modalService: ModalService,
        private el: ElementRef
    ) {
        this.element = this.el.nativeElement;
    }

    public ngOnInit(): void {
        if (!this.id) {
            console.error('modal must have an id');

            return;
        }

        // move element to bottom of page (just before </body>) so it can be displayed above everything else
        document.body.appendChild(this.element);

        // close modal on background click
        this.element.addEventListener('click', (el: PointerEvent) => {
            if (el && el.target && el.target instanceof HTMLElement && el.target.className === 'sew-modal') {
                this.close();
            }
        });

        // add self (this modal instance) to the modal service so it's accessible from controllers
        this.modalService.add(this);
    }

    // remove self from modal service when component is destroyed
    public ngOnDestroy(): void {
        if (this.id) {
            this.modalService.remove(this.id);
        }
        this.element.remove();
    }

    public open(): void {
        this.element.style.display = 'block';
        document.body.classList.add('sew-modal-open');
    }

    public close(): void {
        this.element.style.display = 'none';
        document.body.classList.remove('sew-modal-open');
    }
}
